import { coerceText } from './coerce-text';

export type UiApplicantType = 'corporate' | 'individual';

export function isCorporateApplicant(value: unknown): boolean {
  return uiApplicantType(value) === 'corporate';
}

export function uiApplicantType(value: unknown): UiApplicantType {
  const text = coerceText(value).toLowerCase();
  if (text.includes('corporate')) {
    return 'corporate';
  }
  return 'individual';
}

export function apiApplicantType(value: unknown): 'CORPORATE' | 'INDIVIDUAL' {
  return isCorporateApplicant(value) ? 'CORPORATE' : 'INDIVIDUAL';
}
